import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.config.devtools = true;

export default new Vuex.Store({
  state: {
    selectedIds: [],
    error: {},
    user: null,
    companies: [],
    customerId: null,
    companyId: null,
    version: localStorage.getItem('version'),
    message: {message:'',frequency:'Once'},
    showMessage: false,
    oldVersion: '',
    newVersion: false,
    drawer: false
  },
  getters: {
    company: state => state.companies.find(company => company.customerId === state.customerId),
    userSettings : state => {
      const company = state.companies.find(company => company.customerId === state.customerId);
      return company ? JSON.parse(company.userSettings) : null;
    }
  },
  mutations: {
    pushSelectedId(state, selectedId) {
      state.selectedIds.push(selectedId);
    },
    resetSelectedIdStack(state) {
      state.selectedIds.splice(0);
    },
    _popSelectedId(state) {
      state.selectedIds.pop();
    },
    setError(state, error) {
      state.error = error;
    },
    clearUser(state) {
      state.user = null;
      delete state.customerId;
      delete state.companyId;
      localStorage.removeItem('customerId');
    },
    setUser(state, user) {
      state.user = user;
    },
    setDrawer(state, drawer) {
      state.drawer = drawer;
    },
    setCompanies(state, companies) {
      state.companies = companies;
      if (!state.customerId)
        state.customerId = localStorage.getItem('customerId');
      if (state.customerId && companies.find(company => company.customerId === state.customerId) == undefined)
        state.customerId = null;
/*
      if (!state.customerId && companies.length > 0) {
        state.customerId = companies[0].customerId;
        localStorage.setItem('customerId', state.customerId);
      }
      */
      if (state.customerId) {
        document.title = `PŪRTRAK - Customer Portal`;
        state.companyId = companies.find(company => company.customerId === state.customerId).companyId;
      }
    },
    setCustomerId(state, customerId) {
      state.customerId = customerId;
      localStorage.setItem('customerId', customerId);
      state.companyId = state.companies.find(company => company.customerId === state.customerId).companyId;
      document.title = `PŪRTRAK - Customer Portal`;
    },
    clearCustomerId(state) {
      delete state.customerId;
      delete state.companyId;
      localStorage.removeItem('customerId');
      document.title = `PŪRTRAK - Customer Portal`;
    },
    setVersion(state, version) {
      if (state.version && state.version !== version) {
        state.newVersion = true;
        state.oldVersion = state.version;
      }
      state.version = version;
      localStorage.setItem('version', version);
    },
    setMessage(state, message) {
      const lastMessage = state.message.message !== message.message ||
                          state.message.frequency !== message.frequency ? 0 :
                          parseInt(localStorage.getItem('lastMessage') ?? 0);
      state.message = message;
      const now = Math.floor(Date.now()/(60*60*1000));
      if (!state.message.message)
        ;
      else if (!lastMessage)
        state.showMessage = true;
      else {
        const elapsedHours = now - lastMessage;
        if (message.frequency === 'Hourly' &&  elapsedHours >= 1)
          state.showMessage = true;
        else if (message.frequency === 'Daily' && elapsedHours >= 24)
          state.showMessage = true;
      }
      if (state.showMessage)
        localStorage.setItem('lastMessage', now)
    },
    clearShowMessage(state) {
      state.showMessage = false;
    }
  },
  actions: {
    popSelectedId({state,commit}) {
      const length = state.selectedIds.length;
      const id = length ? state.selectedIds[length-1] : null;
      commit('_popSelectedId');
      return id;
    },
    async refreshCompanies({state,commit}) {
      const results = await Vue.prototype.$apiCall(`query store($userId:String!) {
                                                      portalCustomersForUser(userId:$userId) {
                                                        customerId,customerName,companyId,companyName
                                                      }
                                                    }`,
                                                    {userId:state.user.sub});
      if (!results.error)
        commit('setCompanies', results.data.portalCustomersForUser);
      return results.error;
    }
  },
  modules: {
  }
})
